import { FC } from 'react';
import classnames from 'classnames';
import './skeleton.scss';

type Props = {
  className?: string;
  width?: React.CSSProperties['width'];
  height?: React.CSSProperties['height'];
  style?: React.CSSProperties;
  isLight?: boolean;
};

export const Skeleton: FC<Props> = ({
  className = '',
  style,
  width,
  height,
  isLight,
}) => {
  return (
    <div
      className={classnames('skeleton', className, {
        skeleton_light: isLight,
      })}
      style={{
        height: height || '100%',
        width: width || '100%',
        ...style,
      }}></div>
  );
};
